import { Component, HostListener, Input } from '@angular/core';
import { faChevronLeft, faX } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FilterResultService } from 'src/app/services/filter-result.service';


@Component({
  selector: 'app-filter-result',
  templateUrl: './filter-result.component.html',
  styleUrls: ['./filter-result.component.scss']
})
export class FilterResultComponent {
  faChevronLeft = faChevronLeft;
  @Input('selectedSortOption') selectedSortOption: string = '0';
  faClose = faX;
  constructor(
    public activeModal: NgbActiveModal,
    public filterResultService: FilterResultService
  ){

  }

  toggleFilter(){
    this.filterResultService.toggleFilter();
  }

  onButtonClick() {
    this.activeModal.close({ 
      action: 'filter', 
      filterValue: Number(this.selectedSortOption) 
    });
  }

  cleanFilters(){
    const filterValue = '0';
    this.activeModal.close({ 
      action: 'filter', 
      filterValue: Number(filterValue) 
    });
  }

  onNo(){
    this.activeModal.close({ action: 'close' });
  }
}
